/**Multiselector de varias guias */
import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { toSelected } from "./logic";
import { columnas } from "./columns";


export interface Props {
    /**Id de las descripciones de paquetes seleccionadas seleccionados */
    value: number[];
    onChange: (value: number[]) => void;
    items: models.DescripcionPaqueteDTO[];
    hideBusqueda?: boolean;
    label?: string;
}

/**Multiselector de las descripciones de paquetes, lo unico que muestra es el grid, no muestra los filtros ni ninguna otra cosa  */
class MultiselectorDescripcionPaqueteListNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = (props: Props) => props.items;
    itemsFiltrados = createSelectorRx(this.items, (items) => items);
    itemsSelected = createSelectorRx(this.value, this.itemsFiltrados, (value, items) => toSelected(items, value));

    onSeleccionar = (cliente: models.DescripcionPaqueteDTO, selected: boolean) => {
        const old = this.value(this.props);
        const next = selected ? [...old, cliente.IdRegistro] : old.filter(x => x != cliente.IdRegistro);
        this.props.onChange(next);
    };

    render() {
        const cols = columnas(this);
        return (
            <div>
                {this.props.label && <kea.Title titulo={this.props.label} size="h4" />}
                <kea.Grid2 cookieKey="multiselectorDescripcionPaquetes" items={this.itemsSelected(this.props)} columnas={cols} hideBusqueda={this.props.hideBusqueda} />
            </div>
        );
    }
}

export const MultiselectorDescripcionPaqueteList = componentToRx(MultiselectorDescripcionPaqueteListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/descripcionpaquetes/multiselectordescripcionpaquetes.tsx